export default function TotalEarnings({ miningTotal, electricityTotal }: any) {
  return (
    <div className="flex flex-col p-7 bg-slate-100 border-t border-gray-100">
      <div className="flex-shrink-0 mb-3 text-gray-500 font-bold">BTC Earnings (€ Net)</div>
      <div className="text-blue-600 text-center text-5xl font-['Avenir-Bold'] tracking-tighter">
        {miningTotal && electricityTotal ? (miningTotal.eurosMined - electricityTotal.eurosConsumedByMiners).toLocaleString("en-GB", {
          style: "currency",
          currency: "EUR",
        }) : "€0"}
      </div>
      <div className="mt-1 text-slate-400 text-center text-xl">
        {miningTotal && electricityTotal ? 
          (miningTotal.exchangeRate === 0 ? 0 :
          ((miningTotal.eurosMined - electricityTotal.eurosConsumedByMiners) / miningTotal.exchangeRate).toFixed(4)
          ) 
        : 0} BTC
      </div>
    </div>
  );
}
